import { useMemo, useState } from 'react';
import { Icon } from '../components/Icon';
import { playerCount, time } from '@elena/shared';
import { useElena } from '../state';

export function Server() {
  const { status, refresh, send } = useElena();
  const [query, setQuery] = useState('');
  const [busy, setBusy] = useState(false);
  const s = status?.server;

  const players = useMemo(() => {
    const q = query.trim().toLowerCase();
    const list = [...(s?.players ?? [])].sort((a, b) => a.id - b.id);
    return q ? list.filter((p) => p.name.toLowerCase().includes(q) || String(p.id) === q) : list;
  }, [s, query]);

  const reload = async () => {
    setBusy(true);
    await refresh();
    setBusy(false);
  };

  return (
    <div className="page">
      <header className="page-head">
        <div>
          <h1>{s?.name ?? 'Server'}</h1>
          <p className="muted">{s?.hostname ?? 'FiveM server na tvom VPS-u'}</p>
        </div>
        <div className="row gap-8 wrap">
          <button
            type="button"
            className="btn"
            onClick={() => send('Kakvo je stanje na serveru i ko je unutra?', false)}
          >
            Pitaj Elenu
          </button>
          <button
            type="button"
            className="btn primary"
            onClick={() => void reload()}
            disabled={busy}
          >
            <Icon name="refresh" size={16} /> Osveži
          </button>
        </div>
      </header>

      <section className="kpis card" aria-label="Pokazatelji">
        <div className="kpi">
          <span className="muted small">Status</span>
          <span className={`kpi-value ${s?.online ? 'ok' : 'bad'}`}>
            {s ? (s.online ? 'Online' : 'Offline') : '…'}
          </span>
        </div>
        <div className="kpi">
          <span className="muted small">Igrači</span>
          <span className="kpi-value">{s ? playerCount(s.players.length, s.maxPlayers) : '…'}</span>
        </div>
        <div className="kpi">
          <span className="muted small">Resursi</span>
          <span className="kpi-value">{s?.resources ?? '–'}</span>
        </div>
        <div className="kpi">
          <span className="muted small">Provereno</span>
          <span className="kpi-value">{s ? time(s.checkedAt) : '…'}</span>
        </div>
      </section>

      <section className="card" aria-labelledby="players-title">
        <header className="card-head wrap">
          <h2 id="players-title">Igrači online</h2>
          <label htmlFor="player-q" className="sr-only">
            Traži igrača
          </label>
          <input
            id="player-q"
            className="field small-field"
            placeholder="Ime ili ID"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </header>
        {players.length === 0 ? (
          <p className="muted">
            {s?.online ? 'Nema igrača koji odgovaraju pretrazi.' : 'Server ne odgovara.'}
          </p>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Ime</th>
                  <th scope="col" className="num-col">
                    Ping
                  </th>
                </tr>
              </thead>
              <tbody>
                {players.map((p) => (
                  <tr key={p.id}>
                    <td className="muted">{p.id}</td>
                    <td className="strong">{p.name}</td>
                    <td className={`num-col ${p.ping > 150 ? 'bad' : ''}`}>{p.ping} ms</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
